var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "v-switch",
      class: [_vm.sizeCss, { "v-switch--disabled": _vm.isDisabled }],
    },
    [
      _c(
        "span",
        { staticClass: "v-switch__item", on: { click: _vm.clickSwitch } },
        [
          _c("span", {
            staticClass: "v-switch__icon",
            class: {
              "v-switch__icon--active": _vm.value === _vm.onValue,
              "v-switch__icon--disabled": _vm.isDisabled,
            },
            attrs: { name: _vm.name, "data-name": _vm._name },
          }),
          _vm.onText && _vm.offText
            ? _c("span", { staticClass: "v-switch__label" }, [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.value === _vm.onValue ? _vm.onText : _vm.offText
                    ) +
                    " "
                ),
              ])
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }